import { ReportsApi } from "reports-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function createReportApi(): ReportsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';
  if(isGatewayEnabled){
    const basePath = process.env.REACT_APP_REPORTS_API_URL_GATEWAY;
  const axiosInstance: AxiosInstance = spire360ApiClient;
  return new ReportsApi(

    undefined,
    `${process.env.REACT_APP_REPORTS_API_URL_GATEWAY}`,
    axiosInstance

    // "http://localhost:4001"
  );

  }
  else{
  return new ReportsApi(

    createCommonConfigurationForApis(),
    `${process.env.REACT_APP_REPORTS_API_URL}`

    // "http://localhost:4001"
  );
  }
  
}
